import { useContext, useMemo } from 'react'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { initialRooms } from 'lib/offer/occupancyUtils'
import { isReservationAvailableForRoom } from 'lib/checkout/cartReservationUtils'
import getLuxLoyaltyTargetUpgradePackage from 'luxLoyalty/lib/getLuxLoyaltyTargetUpgradePackage'

function useLuxLoyaltyOfferPageTargetRoomUpgradePkgAvailability(
  originPackage: App.Package,
  durationPackageOptions: Array<OfferPackageOptionView>,
): boolean {
  const { offer, rooms = initialRooms } = useContext(OfferPageStateContext)
  const targetUpgradePackage = getLuxLoyaltyTargetUpgradePackage(offer, originPackage)

  const shouldShowUpgradeAvailableForPkg = useMemo<boolean>(() => {
    if (!targetUpgradePackage || !offer || !rooms) return false
    // Target has invalid duration selected
    if (!durationPackageOptions.find(option => option.package.id === targetUpgradePackage.id)) return false
    // Target has invalid room capacity selected
    if (!rooms.every(room => isReservationAvailableForRoom(room, targetUpgradePackage.roomRate?.capacities ?? [], offer))) return false
    return true
  }, [durationPackageOptions, offer, rooms, targetUpgradePackage])

  return shouldShowUpgradeAvailableForPkg
}

export default useLuxLoyaltyOfferPageTargetRoomUpgradePkgAvailability
